import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Heart = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M12 21.4L13.4 20C18.6 15.4 22 12.3 22 8.5C22 5.4 19.6 3 16.5 3C15.4394 3 14.3788 3.31137 13.464 3.86126C12.9124 4.1928 12.4137 4.61103 12 5.1C11.5863 4.61103 11.0876 4.1928 10.536 3.86126C9.62115 3.31137 8.56058 3 7.5 3C4.4 3 2 5.4 2 8.5C2 12.3 5.4 15.4 10.6 20L12 21.4ZM10.9878 7L10.4732 6.39188C9.74706 5.53369 8.60221 5 7.5 5C5.50457 5 4 6.50457 4 8.5C4 9.74557 4.53916 11.0304 5.89508 12.6801C7.27382 14.3575 9.29155 16.1723 11.9251 18.502L11.971 18.5425L12 18.5716L12.029 18.5425L12.0749 18.502C14.7084 16.1723 16.7262 14.3575 18.1049 12.6801C19.4608 11.0304 20 9.74557 20 8.5C20 6.50457 18.4954 5 16.5 5C15.3978 5 14.2529 5.53369 13.5268 6.39188L13.0122 7H10.9878Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Heart;
